import * as Views from "./views";
import * as Wizards from "./wizards";

const Module = {
    name: "revenueinvoices",
    defaultRoutePath: "/administrations/revenueinvoice",
    menuItemScope: "administration",
    menuItemName: "revenueinvoices",

    routes: [
        {
            path: "/administrations/revenueinvoice",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Views.Default,
                },
                {
                    path: "list",
                    Component: Views.List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: Views.List,
        },
        {
            path: "detail",
            Component: Views.Detail,
        },
        {
            path: "create",
            Component: Wizards.Create,
        },
    ],

}

export default Module;
